export default "__VITE_ASSET__CjlbqfwG__"